import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=f77dc234&scoped=true&"
import script from "./publish.vue?vue&type=script&lang=js&"
export * from "./publish.vue?vue&type=script&lang=js&"
import style0 from "./publish.vue?vue&type=style&index=0&id=f77dc234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77dc234",
  null
  
)

export default component.exports